import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useOrganizerStore } from "../utils/store";

export default function OrganizerProtectedRoute({ children }) {
  const { user } = useOrganizerStore();
  const navigate = useNavigate();
 const location = useLocation();
  useEffect(() => {
   if (!user.isAuthenticated || user.role !== "organizer") {
     navigate("/organizerLogin", {
       replace: true,
       state: {
         from: location.pathname + location.search,
       },
     });
   }
  }, [user, navigate, location]);

  if (!user.isAuthenticated || user.role !== "organizer") {
    return null;
  }

  return children;
}
